import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TenantContext = createContext(null);

export const useTenant = () => {
    const context = useContext(TenantContext);
    if (!context) {
        throw new Error('useTenant must be used within TenantProvider');
    }
    return context;
};

export const TenantProvider = ({ children, organizationCode }) => {
    const [tenant, setTenant] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (organizationCode) {
            fetchTenant();
        } else {
            setLoading(false);
        }
    }, [organizationCode]);

    const fetchTenant = async () => {
        try {
            const response = await axios.get(`${API}/organizations/${organizationCode}/public`);
            setTenant(response.data);
            
            // Apply CSS variables
            document.documentElement.style.setProperty('--tenant-primary', response.data.primary_color || '#0f172a');
            document.documentElement.style.setProperty('--tenant-primary-foreground', '#ffffff');
        } catch (err) {
            console.error('Failed to fetch tenant:', err);
            setError('Organization not found');
        } finally {
            setLoading(false);
        }
    };

    const updateTenant = (updates) => {
        if (tenant) {
            const updated = { ...tenant, ...updates };
            setTenant(updated);
            if (updates.primary_color) {
                document.documentElement.style.setProperty('--tenant-primary', updates.primary_color);
            }
        }
    };

    const value = {
        tenant,
        loading,
        error,
        organizationCode,
        updateTenant,
        primaryColor: tenant?.primary_color || '#0f172a'
    };

    return (
        <TenantContext.Provider value={value}>
            {children}
        </TenantContext.Provider>
    );
};
